module.exports = __webpack_public_path__ + "static/media/girl-on-computer.481cf4ba.png";